import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import PageHeadingSection from "../../../common/pageheading/PageHeadingSection";
import SectionTab from "../../../common/sectiontab/SectionTab";
import Breadcrumbs from "../../../common/BreadCrum/BreadCrum";
import MaintenanceSetup from "./MaintenanceSetup";
import MyInvoices from "./MyInvoices";
import storageService from "../../../../utils/storageService";

const MaintenanceModule = () => {
    const navigate = useNavigate();
    const roleId = Number(storageService.getItem("roleId")); // 3 = Site Admin, 4 = Unit Admin
    const [activeTab, setActiveTab] = useState(roleId === 4 ? "invoices" : "setup");

    const allTabs = [
        { key: "setup", label: "Maintenance Setup", component: MaintenanceSetup },
        { key: "invoices", label: "My Invoices", component: MyInvoices }
    ];

    const tabs = roleId === 4
        ? allTabs.filter(t => t.key === "invoices")
        : allTabs.filter(t => t.key === "setup");

    return (
        <div className="bg-dashboardbg px-6 py-4 border border-bordercolor flex flex-col rounded-lg flex-1 overflow-y-auto pt-4 gap-4 scrollbar-hide h-full">
            <Breadcrumbs />
            <PageHeadingSection
                mainHeading="Maintenance Management"
                subHeading="Manage and split unit maintenance, or pay your invoices."
                primaryBtnText={roleId === 3 ? "Add Maintenance" : null}
                primaryBtnIcon={faPlus}
                PrimaryOnClick={() => navigate("/zentcomm/maintenance/add")}
            />

            <div className="flex-1 flex flex-col shrink-0 min-h-[calc(100vh-250px)]">
                <SectionTab
                    tabs={tabs}
                    defaultTab={roleId === 4 ? "invoices" : "setup"}
                    activeTab={activeTab}
                    onTabChange={(key) => setActiveTab(key)}
                />
            </div>
        </div>
    );
};

export default MaintenanceModule;
